import Service, { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { task } from 'ember-concurrency';

export default class OrganizationRepo extends Service {
  @service store;

  search = task(waitFor(async (searchTerm) => {
    return await this.store.query('organization', { searchTerm });
  }));
}
